import { CalculationResponseResultPremiumDto } from './CalculationResponseResultPremiumDto';
import { CalculationRequestDto } from 'src/app/model/business/CalculationRequestDto';

export class QuotationRequestDto {
  calculationRequestDto: CalculationRequestDto;
  premiumResponse: CalculationResponseResultPremiumDto;
  intermediaryName: string;
  intermediaryEmail: string;
  intermediaryPhone: string;
}

export class QuotationRequestFailedKnowledgeTestDto {
  calculationRequestDto: Pick<CalculationRequestDto, 'productType' | 'policyTerms' | 'variables' | 'insureds' | 'dateOfCommencement'>;
  premiumResponse: CalculationResponseResultPremiumDto;
  intermediaryName: string;
  intermediaryEmail: string;
  intermediaryPhone: string;
  sendToIntermediary: boolean;
  customerPhone: string;
  customerEmail: string;
  customerName: string;
  customerGender: string;
}
